import { useEffect } from "react";

export const useInitCalendarDayMenu = ({ tabState, setTabState, allCheckedApplications, isDayBlocked }) => {
  // const translates = useMemo(
  //   () => ({
  //     applicationsTab: intl.formatMessage({ id: "msg.tabMenu.applications" }),
  //     calendarTab: intl.formatMessage({ id: "msg.tabMenu.calendar" }),
  //     tabMenuSuggest: intl.formatMessage({ id: "msg.tabMenu.suggest" }),
  //     tabMenuCancel: intl.formatMessage({ id: "msg.tabMenu.cancel" }),
  //     tabMenuSuggestConfirm: intl.formatMessage({ id: "msg.tabMenu.confirm" }),
  //     tabMenuLock: intl.formatMessage({ id: "msg.tabMenu.lock" }),
  //     tabMenuUnlock: intl.formatMessage({ id: "msg.tabMenu.unlock" }),
  //   }),
  //   [intl]
  // );

  // const setTab = (tab) => {
  //   setTabState((tabState) => ({ ...tabState, tab }));
  // };
  useEffect(() => {
    setTabState({ ...tabState });
  }, [allCheckedApplications, isDayBlocked]); // eslint-disable-line react-hooks/exhaustive-deps
};
